module.exports = __webpack_public_path__ + "static/img/how-to.c7ba3808.png";